
import {
  BrowserRouter as Router,
  Route,
  Routes,
} from "react-router-dom";
import ScrollToTop from "./components/ScrollToTop";
import Auth from "./pages/Auth";
import Account from "./pages/Account";
import Marketplace from "./pages/Marketplace";
import FollowStrategy from "./pages/FollowStrategy";
import FollowStrategyFree from "./pages/FollowStrategyFree";
import FollowStrategyPremiumExisting from "./pages/FollowStrategyPremiumExisting";
import ThankYouFree from "./pages/ThankYouFree";
import ThankYouPremium from "./pages/ThankYouPremium";
import ThankYou from "./pages/ThankYou";
import Admin from "./pages/Admin";
import MonitoringDashboard from "@/pages/MonitoringDashboard";
import StrategyDetail from "./components/StrategyDetail";
import Index from "./pages/Index";
import Terms from "./pages/Terms";
import Privacy from "./pages/Privacy";
import RiskDisclaimer from "./pages/RiskDisclaimer";
import HowItWorks from "./pages/HowItWorks";
import KnowledgeHub from "./pages/KnowledgeHub";
import AboutUs from "./pages/AboutUs";
import Pricing from "./pages/Pricing";
import Strategies from "./pages/Strategies";
import GetStarted from "./pages/GetStarted";
import SignUp from "./pages/SignUp";
import Blog from "./pages/Blog";
import CryptoBasics from "./pages/CryptoBasics";
import Glossary from "./pages/Glossary";
import CryptoTradingQuiz from "./pages/CryptoTradingQuiz";
import Article from "./pages/Article";
import { LandingLayout, OkxLanding, PhemexLanding } from "./pages/landing";
import AdminOrProviderRoute from "./components/auth/AdminOrProviderRoute";
import ProtectedRoute from "./components/auth/ProtectedRoute";
import AdminDataProvider from "./components/admin/AdminDataProvider";
import ArticleEditor from "./components/admin/articles/ArticleEditor";
import ArticlePreviewPage from "./pages/admin/ArticlePreviewPage";
import Premium from "./pages/Premium";
import NewProvider from "./pages/admin/NewProvider";
import Faqs from "./pages/Faqs";
import Bitcoin from "./pages/basics/Bitcoin";
import Cryptocurrency from "./pages/basics/Cryptocurrency";
import Wallets from "./pages/basics/Wallets";
import CopyTrading from "./pages/basics/CopyTrading";
import ResetPassword from "./pages/ResetPassword";
import Payment from "./pages/Payment";
import NotFound from "./pages/NotFound";
import Home from "./pages/Home";

function App() {
  return (
    <Router>
      <ScrollToTop />
      <Routes>
        <Route path="/" element={<Index />} />
        <Route path="/auth" element={<Auth />} />
        <Route path="/signup" element={<SignUp />} />
        <Route path="/account" element={<ProtectedRoute><Account /></ProtectedRoute>} />
        <Route path="/marketplace" element={<ProtectedRoute><Marketplace /></ProtectedRoute>} />
        <Route path="/strategy/:id" element={<StrategyDetail isOpen={true} onClose={() => {}} strategy={undefined} />} />
        <Route path="/follow-strategy" element={<ProtectedRoute><FollowStrategy /></ProtectedRoute>} />
        <Route path="/follow-strategy-free" element={<ProtectedRoute><FollowStrategyFree /></ProtectedRoute>} />
        <Route path="/follow-strategy-premium-existing" element={<ProtectedRoute><FollowStrategyPremiumExisting /></ProtectedRoute>} />
        <Route path="/thank-you" element={<ProtectedRoute><ThankYou /></ProtectedRoute>} />
        <Route path="/thank-you-free" element={<ProtectedRoute><ThankYouFree /></ProtectedRoute>} />
        <Route path="/thank-you-premium" element={<ProtectedRoute><ThankYouPremium /></ProtectedRoute>} />
        <Route path="/terms" element={<Terms />} />
        <Route path="/privacy" element={<Privacy />} />
        <Route path="/disclaimer" element={<RiskDisclaimer />} />
        <Route path="/how-it-works" element={<HowItWorks />} />
        <Route path="/knowledge-hub" element={<KnowledgeHub />} />
        <Route path="/knowledge-hub/blog" element={<Blog />} />
        <Route path="/knowledge-hub/basics" element={<CryptoBasics />} />
        <Route path="/knowledge-hub/glossary" element={<Glossary />} />


        <Route path="/crypto-trading-quiz" element={<CryptoTradingQuiz />} />
        <Route path="/knowledge-hub/basics/bitcoin" element={<Bitcoin />} />
              <Route path="/knowledge-hub/basics/cryptocurrency" element={<Cryptocurrency />} />
              <Route path="/knowledge-hub/basics/wallets" element={<Wallets />} />
              <Route path="/knowledge-hub/basics/copy-trading" element={<CopyTrading />} />

              <Route path="/payment" element={<ProtectedRoute><Payment /></ProtectedRoute>} />
              <Route path="/reset-password" element={<ResetPassword />} />

        <Route path="/articles/:slug" element={<Article />} />
        <Route path="/about-us" element={<AboutUs />} />
        <Route path="/faqs" element={<Faqs />} />
        <Route path="/pricing" element={<Pricing />} />
        <Route path="/strategies" element={<Strategies />} />
        <Route path="/get-started" element={<GetStarted />} />
        <Route path="/admin" element={<AdminOrProviderRoute><Admin /></AdminOrProviderRoute>} />
        <Route path="/admin/monitoring" element={<MonitoringDashboard />} />
        <Route path="/admin/provider/new" element={<AdminOrProviderRoute><NewProvider /></AdminOrProviderRoute>} />
        {/*<Route path="/premium" element={<Premium />} />*/}
        <Route path="/home" element={<Home />} />

        <Route path="/admin/articles/new" element={
                <AdminOrProviderRoute>
                  <AdminDataProvider>
                    <ArticleEditor />
                  </AdminDataProvider>
                </AdminOrProviderRoute>
              } />
              <Route path="/admin/articles/:id" element={
                <AdminOrProviderRoute>
                  <AdminDataProvider>
                    <ArticleEditor />
                  </AdminDataProvider>
                </AdminOrProviderRoute>
              } />
              <Route path="/admin/article-preview/:id" element={
                <AdminOrProviderRoute>
                  <AdminDataProvider>
                    <ArticlePreviewPage />
                  </AdminDataProvider>
                </AdminOrProviderRoute>
              } />
        
        {/* Landing pages using LandingLayout */}
        <Route element={<LandingLayout />}>
          <Route path="/landing/okx" element={<OkxLanding />} />
          <Route path="/landing/phemex" element={<PhemexLanding />} />
        </Route>
        
        {/* Catch-all route for 404 pages */}
        <Route path="*" element={<NotFound />} />
      </Routes>
    </Router>
  );
}

export default App;
